import { WidgetConfigWithHideableToolbar } from 'widgets/WidgetToolbarShowHidePanel/WidgetConfigWithHideableToolbar';
import { DockingConfig } from '@instinet-analytics/semantic-ui-components';
import { ConfigStateWithGridSupport } from 'widgets/store/grid/reducer';
import { IndexEventWidgetGridColumn } from 'widgets/indexEvents/components/grid/columns';
import { SortDirection } from '@instinet-analytics/core-lib';

export interface IndexEventsWidgetConfigState
    extends WidgetConfigWithHideableToolbar,
        ConfigStateWithGridSupport<IndexEventWidgetGridColumn>,
        DockingConfig {
    side?: string;
    tradeCategories: string[];
}

export const initialIndexEventsConfiguration: IndexEventsWidgetConfigState = {
    dockPosition: 'Bottom',
    dockPercentage: 30,
    sort: [{ colId: 'symbol', sort: SortDirection.ASCENDING }],
    visibleColumns: ['symbol', 'net', 'gross', 'liquidity'],
    columnWidths: { symbol: 90, net: 85, gross: 85, liquidity: 90 },
    tradeCategories: [],
};
